module.exports = __webpack_public_path__ + "img/img-best-item01.5953b62b.png";